export const userMenuTourMeta = {
  releaseDate: '2026-04-28', // fecha de deploy — solo usuarios creados desde esta fecha ven este tour
  showTo: 'existing'
}

export const stepsMenuConfiguration = [
  {
    element: "#configuration",
    title: "Personaliza tu experiencia en Falkon",
    intro: "Desde <strong>Configuración</strong> puedes guardar información clave de tus envíos para crearlos más rápido y con menos esfuerzo.",
    position: 'left'
  },
  {
    element: "#personalizacion-empaques",
    title: "Configura los empaques que usas normalmente",
    intro: "Guarda las medidas y el peso de tus empaques para seleccionarlos fácilmente cada vez que crees un envío.",
    position: 'right'
  },
  {
    element: "#add-packing-btn",
    title: "Crea tus empaques en segundos",
    intro: "Ingresa las dimensiones y peso de tus empaques más usados. Podrás editarlos o eliminarlos cuando lo necesites.",
    position: 'right'
  },
  {
    element: "#personalizacion-destinatarios",
    title: "Guarda tus destinatarios más frecuentes",
    intro: "Registra las personas o lugares a los que envías con más frecuencia. Y al crear un envío, solo tendrás que seleccionarlos sin volver a escribir sus datos.",
    position: 'right'
  },
  {
    element: ".add-destinatary-btn",
    title: "Crea tu lista de destinatarios frecuentes",
    intro: "Guarda la información de tus clientes o puntos de entrega habituales. Podrás editarlos o eliminarlos en cualquier momento.",
    position: 'right'
  }
]